import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { ORG_ROLE_ICON, ORG_ROLE_LABEL, ORG_ROLE_PERMISSIONS, ORG_ROLE_TAGLINE } from "@/lib/org-roles";
import type { OrgRole } from "@/lib/api";
import { Check } from "lucide-react";

export function RoleMenuItem({
  role,
  selected,
  disabled,
  onSelect,
}: {
  role: OrgRole;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
}) {
  const Icon = ORG_ROLE_ICON[role];
  return (
    <DropdownMenuItem disabled={disabled} onClick={onSelect} className="items-start gap-2 py-2">
      <Icon className="size-4 mt-0.5 shrink-0 text-muted-foreground" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">{ORG_ROLE_LABEL[role]}</span>
          {selected && <Check className="size-3.5 ml-auto text-foreground/70" />}
        </div>
        <p className="text-xs text-muted-foreground leading-snug whitespace-normal">{ORG_ROLE_TAGLINE[role]}</p>
      </div>
    </DropdownMenuItem>
  );
}

export function RolePermissionsPanel({ role }: { role: OrgRole }) {
  return (
    <div className="rounded-md border bg-muted/30 p-3 space-y-2">
      <span className="text-xs font-medium">{ORG_ROLE_LABEL[role]} role:</span>
      <ul className="space-y-1">
        {ORG_ROLE_PERMISSIONS[role].map((line) => (
          <li key={line} className="flex gap-2 text-xs text-muted-foreground">
            <Check className="size-3 shrink-0 mt-0.5 text-foreground/60" />
            <span>{line}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
